import React from 'react';
import { NavLink, withRouter } from "react-router-dom";
import IntlMessages from 'util/IntlMessages';

const Error500 = () => (
    <div className="page-error-container animated slideInUpTiny animation-duration-3">
        <div className="page-error-content">

            <div className="error-code mb-4 animated zoomInDown">
                <img src="assets/images/error.png" />
            </div>
            <h2 className="text-center fw-regular title animated bounceIn animation-delay-10">
                Ha ocurrido un error con el pago, vuelve a intentarlo.</h2>

            <p className="text-center animated flipInX animation-delay-20">
                <NavLink className="btn btn-primary" to="/app/users/list-users">
                    Volver al inicio
                </NavLink>
            </p>
        </div>
    </div>
);

export default Error500;



// WEBPACK FOOTER //
// ./app/routes/extraPages/routes/cancel/index.js